type AssetUrls = {
    [name: string]: AssetUrls | string
}

type ImageAssetMap = Map<string, HTMLImageElement>

export class AssetManager {
    public image_urls: AssetUrls;
    public images: ImageAssetMap;

    constructor() {
        this.image_urls = require("../../assets/images/**/*.png");
        this.images = new Map();
        console.log(this.image_urls);
    }

    public get_url(image_id: string): string {
        const image_id_parts = image_id.split('.');
        const url = image_id_parts.reduce((url: AssetUrls | string, id_part: string) => {
            if (typeof url === "string") throw new Error("Could not find asset-subfolder " + id_part + " at " + image_id);
            return url[id_part];
        }, this.image_urls);
        if (typeof url !== "string") throw new Error("Image Id only refers to a folder " + image_id);
        return url;
    }

    public get(image_id: string): HTMLImageElement {
        let image = this.images.get(image_id);
        if (image) return image;
        image = new Image();
        image.src = this.get_url(image_id);
        this.images.set(image_id, image);
        return image;
    }
}